import { Globe, FolderOpen, Plus, Eye, BookOpen } from 'lucide-react'

export type PanelType = 'browser' | 'files' | 'preview' | 'docs'

interface PanelToggleProps {
  activePanels: Set<PanelType>
  availablePanels: PanelType[]
  onToggle: (panel: PanelType) => void
}

const panelInfo: Record<PanelType, { icon: typeof Globe; name: string }> = {
  browser: { icon: Globe, name: 'Server Browser' },
  files: { icon: FolderOpen, name: 'Files' },
  preview: { icon: Eye, name: 'Preview' },
  docs: { icon: BookOpen, name: 'Docs' },
}

export default function PanelToggle({
  activePanels,
  availablePanels,
  onToggle,
}: PanelToggleProps) {
  const inactivePanels = availablePanels.filter((p) => !activePanels.has(p))

  if (inactivePanels.length === 0) return null

  return (
    <div className="flex items-center gap-1">
      <span className="text-xs text-muted-foreground mr-1">Add:</span>
      {inactivePanels.map((panel) => {
        const info = panelInfo[panel]
        return (
          <button
            key={panel}
            onClick={() => onToggle(panel)}
            className="flex items-center gap-1.5 px-2 py-1 rounded border border-dashed border-border hover:border-primary hover:bg-secondary/50 text-sm transition-colors"
            title={`Add ${info.name} panel`}
          >
            <Plus className="w-3 h-3" />
            <info.icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline text-xs">{info.name}</span>
          </button>
        )
      })}
    </div>
  )
}
